import { defineComponent as _defineComponent } from 'vue'
import { tiposSanguineos } from '../../../shareds/sharedsIrmao'
import { defineComponent, ref } from 'vue'
import { InputIrmao } from 'common/types/Irmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormGeral',
  props: {
    value: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

defineComponent({
	inheritAttrs: true,
})





return { __sfc: true,emit, tiposSanguineos }
}

})